import { Route } from 'react-router-dom';

import { TenantDetailPage } from './pages/tenant-detail-page.js';
import { TenantFormPage } from './pages/tenant-form-page.js';
import { TenantListPage } from './pages/tenant-list-page.js';

export function tenantRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/tenants" element={<TenantListPage />} />
      {/* Before the parameterised detail route: react-router ranks a static
          segment above a dynamic one, but keeping them in this order means a
          reader does not have to know that to see which wins. */}
      <Route path="/tenants/new" element={<TenantFormPage />} />
      <Route path="/tenants/:tenantId/edit" element={<TenantFormPage />} />
      <Route path="/tenants/:tenantId" element={<TenantDetailPage />} />
    </>
  );
}
